import ActionsBodyTemplate from "./ActionsBodyTemplate";
import StatusTagBodyTemplate from "./StatusTagBodyTemplate";

export { ActionsBodyTemplate, StatusTagBodyTemplate };
